export enum ImageSize {
  "1020x680" = "size1020x680",
  "1200x800" = "size1200x800",
  "768x768" = "size768x768",
}
